// 本地json数据
const localUrl = {
    // 测试模块
    test:{
        // 测试模块首页数据
        index:  '/static/json/test/index.json'
    },
    // 首页数据
    index: '/static/json/index/index.json',
    // news
    news: '/static/json/news/index.json',
    // the_voice_of_judge
    the_voice_of_judge: {
        list: '/static/json/the-voice-of-judge/index.json',
        detail: '/static/json/the-voice-of-judge/detail.json'
    },
    // Laws&Regulations
    laws_regulations: {
        filterList: '/static/json/laws-regulations/index.json',
        list: '/static/json/laws-regulations/list.json'
    },
    // about-the-court
    about_the_court: '/static/json/about-the-court/index.json'
};
export default localUrl;



// WEBPACK FOOTER //
// ./src/js/mock-config.js